import service from '../request/index'


export function weather_information(data) {
	return service({
		url: 'warning_record/weather_information',
		method: "get",
		data
	})
}
export function park_information(data) {
	return service({
		url: 'warning_record/park_information',
		method: "get",
		data
	})
}

export function warning_statistics(data) {
	return service({
		url: 'warning_record/warning_statistics',
		method: "get",
		data
	})
}
export function index(data) {
	return service({
		url: 'warning_record/index',
		method: "get",
		data
	})
}

export function top(data) {
	return service({
		url: 'warning_record/top',
		method: "get",
		data
	})
}


export function homework(data) {
	return service({
		url: 'warning_record/homework',
		method: "get",
		data
	})
}

